var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"thumb",attrs:{"to":_vm.$relativeUrl(_vm.data.link)}},[_c('div',{staticClass:"thumb-media",class:{
      'has-secondary':
        (_vm.data.acf.hover &&
          _vm.data.acf.hover.media &&
          _vm.data.acf.hover.video &&
          _vm.data.acf.hover.video.url) ||
        (_vm.data.acf.hover &&
          !_vm.data.acf.hover.media &&
          _vm.data.acf.hover.image &&
          _vm.data.acf.hover.image.url),
    }},[(_vm.data.gds_featured_image)?_c('Figure',{staticClass:"primary",attrs:{"data":{
        value: {
          src: _vm.data.gds_featured_image,
        },
        settings: {},
      },"theme":"default"}}):_vm._e(),(
        _vm.data.acf &&
          _vm.data.acf.hover &&
          _vm.data.acf.hover.media &&
          _vm.$mq.breakpoint !== '0' &&
          _vm.data.acf.hover.video &&
          _vm.data.acf.hover.video.url
      )?[_c('div',{staticClass:"secondary"},[_c('video',{attrs:{"src":_vm.data.acf.hover.video.url,"autoplay":"","muted":"","loop":"","playsinline":""},domProps:{"muted":true}})])]:(
        _vm.data.acf &&
          _vm.data.acf.hover &&
          _vm.data.acf.hover.image &&
          _vm.data.acf.hover.image.url &&
          _vm.$mq.breakpoint !== '0'
      )?[_c('Figure',{staticClass:"secondary",attrs:{"data":{
          value: {
            src: _vm.data.acf.hover.image,
          },
          settings: {},
        },"theme":"default"}})]:_vm._e()],2),_c('Heading',{staticClass:"title",class:_vm.$mq.breakpoint === '0' ? 'title-mob' : 'title-dsk',attrs:{"value":_vm.data.title.rendered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }